import React, { Component, Fragment } from "react"
import Async from "react-select"
import moment from "moment"
import productPic from "../../assets/images/no-product-image.png"
import excelImg from "../../assets/images/excel.gif"
import Modal from "react-responsive-modal"
import Audit from "../../components/Common/audit"

//services
import {
  MeetingNotesServices,
  CustomerServices,
  UtilityService,
  FileUploadService,
  StyleServices,
  DevelopmentServices,
  ReportServices
} from "../../services"

//components
import PageHeader from "../../components/Page/PageHeader/PageHeader"
import Field from "../../components/Common/Field/Field"
import CustomerDeptSelect from "../../components/Field/CustomerDeptSelect"
import FileUpload from "../../components/FileUpload/FileUpload"
import ImageTopLeft from "../../components/ImageTopLeft"
import AddImageIcon from "../../components/MeetingNote/AddImageIcon"
import SubModule from "../../components/MeetingNote/SubModule"
import Loading from "../../components/Common/Loading"
import { ButtonCol } from "../../components/ButtonCol"

const sketchTemplate = {
  imageName: "",
  imageDescription: "",
  sketchImage: "",
  sampleStyle: "",
  path: "",
  blockRefNumber: "",
  blockRefFrom: "",
  sketch: "",
  sampleDeadline: null,
  fabric: "",
  quality: "",
  artwork: "",
  trim: "",
  fitComments: "",
  wash: "",
  print: "",
  embroidery: "",
  garmentType: null,
  magnumStyleId: null,
  styleReferenceId: null,
  magnumStyleName: "",
  customerRefNumber: "",
  remarks: "",
  pendingItem: [],
  mocks: [],
  customerRefNumber: "",
  IB: [
    {
      price: null,
      qty: null,
      ibDate: null
    }
  ],
  order: [
    {
      price: null,
      qty: null,
      ibDate: null
    }
  ],
  shipmentDetails: [
    {
      quantity: null,
      date: null
    }
  ],
  additionalInfo: "",
  refImages: []
}

class MeetingNote extends Component {
  state = {
    action: "",
    _id: "",
    disabled: false,
    meetingNote: {
      customer: null,
      MNId: "",
      customerDepartmentId: null,
      dateOfMeeting: null,
      buyerName: "",
      present: "",
      placeOfMeeting: "",
      sketches: []
    },
    currentIndex: null,
    currentSketchData: null,
    openSubModule: false,
    customerList: [],
    imageTypeOption: [],
    garmentTypeOption: [],
    styleList: [],
    toggle: "imagelist",
    openmodal: false,
    isLoading: false,

    meetingNoteIDandBarcode: {
      MNId: "",
      qr: null,
      _id: null
    }
  }

  componentDidMount = () => {
    const { action, _id } = this.props.location.state
    if (action == "view") {
      this.setState({
        disabled: true
      })
    }

    if (action === "add") {
      // Get meeting Id and barcode
      MeetingNotesServices.getMeetingIDAndBarcode().then(response => {
        // console.log('meeting notes -id-----', response);

        let { meetingNote } = this.state

        meetingNote.MNId = response.text.data.MNId

        this.setState({
          meetingNote
        })
      })
    }

    if (action !== "add") {
      if (_id !== "") {
        MeetingNotesServices.getMeetingNote(_id)
          .then(response => {
            if (response.status == 200) {
              let meetingNote = { ...this.state.meetingNote }
              Object.keys(meetingNote).forEach(keyName => {
                meetingNote[keyName] = response.text.data[keyName]
              })
              this.setState({
                meetingNote
              })
            }
            response.status == 404 &&
              this.props.getalertMessage("error", response.text.message)
            response.status == 401 && this.props.unauthorisedFunc()
          })
          .catch(error => {
            this.props.getalertMessage("error", error)
          })
      }
    }

    this.setState({
      meetingNote: {
        ...this.state.meetingNote,
        ...{
          dateOfMeeting:
            this.state.meetingNote.dateOfMeeting !== null
              ? this.state.meetingNote.dateOfMeeting
              : new Date()
        }
      }
    })

    this.setState({
      action,
      _id
    })

    if (this.state.action === "add") {
      window.addEventListener("beforeunload", function (event) {
        event.returnValue = "Hellooww"
      })
    }

    this.getCustomerInfo()
    this.getGarmentInfo()
    this.getStyleInfo("")
  }
  componentWillUnmount() {
    if (this.state.action === "add") {
      window.removeEventListener("beforeunload", function (event) {
        event.returnValue = "Hellooww"
      })
    }
  }
  getGarmentInfo = () => {
    MeetingNotesServices.getGarmentInfo()
      .then(async response => {
        if (response.status == 200) {
          let garmentTypeOption = []
          await response.text.data.sysData.map(data => {
            garmentTypeOption.push({
              label: data.name,
              value: data._id
            })
          })
          this.setState({
            garmentTypeOption
          })
        }
      })
      .catch(error => {
        this.props.getalertMessage("error", error)
      })
  }

  getCustomerInfo = () => {
    CustomerServices.customerInfo()
      .then(response => {
        if (response.status === 200) {
          this.setState({
            customerList: response.text.data
          })
        }
      })
      .catch(error => {
        this.props.getalertMessage("error", error.toString())
      })
  }

  createMeetingNote = e => {
    let meetingNote = { ...this.state.meetingNote }
    if (this.state._id !== "") meetingNote._id = this.state._id

    if (this.state._id !== "") {
      meetingNote._id = this.state._id
    }
    meetingNote.sketches = meetingNote.sketches.map((sketch, index) => {
      let data = { ...sketch }
      if (Array.isArray(data.pendingItem) && data.pendingItem.length > 0) {
        if (data.pendingItem[0] !== null) {
          if (Object.keys(data.pendingItem[0]).length > 0) {
            data.pendingItem = data.pendingItem.map(dat => {
              return (dat = dat.value)
            })
          }
        }
      }
      if (Array.isArray(data.mocks) && data.mocks.length > 0) {
        if (data.mocks[0] !== null) {
          if (Object.keys(data.mocks[0]).length > 0) {
            data.mocks = data.mocks.map(dat => {
              return (dat = dat.value)
            })
          }
        }
      }
      return data
    })

    MeetingNotesServices.createMeetingNote(meetingNote)
      .then(response => {
        if (response.status == 200) {
          this.setState({ _id: response.text.data._id })
          this.props.getalertMessage("success", response.text.message)
          // this.props.history.push("/list", { moduleName: "MEETINGROOM" });
        }
        response.status == 401 && this.props.unauthorisedFunc()
        response.status == 404 &&
          this.props.getalertMessage("error", response.text.message)
      })
      .catch(error => {
        this.props.getalertMessage("error", JSON.stringify(error))
      })
  }

  _handleInputChange = (name, value) => {
    let meetingNote = { ...this.state.meetingNote }
    meetingNote[name] = value
    this.setState({ meetingNote })
  }

  _handleCustDeptChange = (index, customer, customerDepartmentId) => {
    let meetingNote = { ...this.state.meetingNote }
    meetingNote.customer = customer
    meetingNote.customerDepartmentId = customerDepartmentId
    this.setState({ meetingNote })
  }

  getRefImages = (refImages, index) => {
    let meetingNote = { ...this.state.meetingNote }
    meetingNote.sketches[index].refImages = refImages
    this.setState({
      meetingNote
    })
  }

  selectNewSample = index => {
    let meetingNote = { ...this.state.meetingNote }
    let sketches = meetingNote.sketches
    sketches[index].sampleStyle = "New Sample"
    meetingNote.sketches = sketches
    this.setState({ meetingNote })
  }

  selectExistingSample = index => {
    let { meetingNote } = this.state
    let sketches = meetingNote.sketches
    sketches[index].sampleStyle = "Existing Sample"
    meetingNote.sketches = sketches
    this.setState({ meetingNote })
  }

  selectNewIB = index => {
    let { meetingNote } = this.state
    let sketches = meetingNote.sketches
    sketches[index].sampleStyle = "IB"
    meetingNote.sketches = sketches
    this.setState({ meetingNote })
  }
  selectNewOrder = index => {
    let { meetingNote } = this.state
    let sketches = meetingNote.sketches
    sketches[index].sampleStyle = "Order"
    meetingNote.sketches = sketches
    this.setState({ meetingNote })
  }

  sketchDataChange = (e, index) => {
    let { meetingNote } = this.state
    let singleSketch = meetingNote.sketches[index]
    singleSketch[e.target.name] = e.target.value
    meetingNote.sketches[index] = singleSketch
    this.setState({ meetingNote })
    let staffDetails = {}
    let allShipping = []
    let shipping = {}
    staffDetails.MNId = window.location.href.split("/")[3].split("?")[1]
    staffDetails._id = this.state.meetingNote.sketches[index]._id
    let sketch = this.state.meetingNote.sketches
    staffDetails.sketchImage =
      this.state[`productImage${index}`] === undefined ||
        this.state[`productImage${index}`] === null
        ? sketch[index].path
        : this.state[`productImage${index}`]
    staffDetails.referenceImages = this.state[`images${index}`]
    let form = document.forms[`${index}`]
    staffDetails.sampleStyle = this.state.meetingNote.sketches[
      index
    ].sampleStyle

    for (var i = 0; i < form.elements.length; i++) {
      if (form.elements[i].name === "qty" || form.elements[i].name === "date") {
        shipping[form.elements[i].name] = form.elements[i].value
        if (Object.keys(shipping).length == 2) {
          allShipping.push(shipping)
          shipping = {}
        }
      } else {
        staffDetails[form.elements[i].name] = form.elements[i].value
      }
    }
    if (
      form.elements[`IB${index}`] !== undefined &&
      form.elements[`IB${index}`].checked === true &&
      form.elements[`existingSample${index}`].checked === true
    ) {
      staffDetails.sampleStyle = "IB"
      staffDetails.IB = allShipping
    } else if (
      form.elements[`order${index}`] !== undefined &&
      form.elements[`order${index}`].checked === true &&
      form.elements[`existingSample${index}`].checked === true
    ) {
      staffDetails.order = allShipping
      staffDetails.sampleStyle = "Order"
    }
  }

  changeMeetingData = e => {
    let { meetingNote } = this.state
    meetingNote[e.target.name] = e.target.value
    this.setState({ meetingNote })
  }

  customerInfoChange = (customerId, departmentId) => {
    let { meetingNote } = this.state
    meetingNote.customerDepartmentId = departmentId
    let customer = meetingNote.customer
    customer._id = customerId
    meetingNote.customer = customer
    this.setState({ meetingNote })
  }

  magnumStyleChange = (e, index, name) => {
    let { meetingNote } = this.state
    let sketches = meetingNote.sketches
    sketches[index].magnumStyleId !== undefined
      ? (sketches[index].magnumStyleId[name] = e.target.value)
      : (sketches[index].magnumStyleId = {})
    if (sketches[index].magnumStyleId === {}) {
      sketches[index].magnumStyleId[name] = e.target.value
    }

    meetingNote.sketches = sketches
    this.setState({ meetingNote })
  }
  magnumStyleNameChange = (e, index) => {
    let { meetingNote } = this.state
    let sketches = meetingNote.sketches
    sketches[index].magnumStyleId.styleName = e.target.value
    meetingNote.sketches = sketches
    this.setState({ meetingNote })
  }
  ibValueChange = (name, value, index, indexVal) => {
    let { meetingNote } = this.state
    let sketches = meetingNote.sketches
    let IB = sketches[index].IB

    IB[indexVal][name] = value
    sketches[index].IB = IB
    meetingNote.sketches = sketches
    this.setState({ meetingNote: meetingNote })
  }
  shippingValueChange = (name, value, indexVal, index) => {
    let { meetingNote } = this.state
    let sketches = meetingNote.sketches
    let shipmentDetails = sketches[index].shipmentDetails
    shipmentDetails[indexVal][name] = value
    sketches[index].shipmentDetails = shipmentDetails
    meetingNote.sketches = sketches
    this.setState({ meetingNote: meetingNote })
  }

  generateStyle = e => {
    this.props.history.push("/StylePage", {
      action: "add",
      _id: "",
      MNId: this.state._id
    })
  }

  updateValue = (name, value, index) => {
    let meetingNote = { ...this.state.meetingNote }
    meetingNote.sketches[index][name] = value
    this.setState({
      meetingNote
    })
  }

  addSketch = () => {
    let meetingNote = { ...this.state.meetingNote }
    meetingNote.sketches.push({ ...sketchTemplate })
    this.setState({
      meetingNote
    })
  }

  removeSketch = index => {
    let meetingNote = { ...this.state.meetingNote }
    let sketches = meetingNote.sketches
    sketches.splice(index, 1)
    meetingNote.sketches = sketches
    this.setState(
      {
        meetingNote
      },
      () => this.backToList()
    )
  }

  changeGarmentType = (garmentType, index) => {
    let meetingNote = { ...this.state.meetingNote }
    meetingNote.sketches[index].garmentType = garmentType
    this.setState({
      meetingNote
    })
  }

  _handleInputChangeForSketch = (name, value, index) => {
    let meetingNote = { ...this.state.meetingNote }
    meetingNote.sketches[index][name] = value
    this.setState({
      meetingNote
    })
  }

  changeImg = (files, index) => {
    FileUploadService.uploadFile(files[0], "meetingnotes")
      .then(response => {
        if (response.status === 200) {
          let meetingNote = { ...this.state.meetingNote }
          meetingNote.sketches[index].sketchImage = response.text.data.url
          this.setState({
            meetingNote
          })
        } else if (response.status === 401) {
          this.props.unauthorisedFunc()
        } else {
          this.props.getalertMessage("error", response.text.message)
        }
      })
      .catch(error => {
        this.props.getalertMessage("error", error.toString())
      })
  }

  removeMNoteImage = index => {
    let { meetingNote } = this.state
    if (meetingNote !== undefined) {
      meetingNote.sketches[index].sketchImage = ""
      this.setState({
        meetingNote
      })
    }
  }

  changePendingItem = (value, index) => {
    let meetingNote = { ...this.state.meetingNote }
    meetingNote.sketches[index].pendingItem = value
    this.setState({
      meetingNote
    })
  }

  changeMocks = (value, index) => {
    let meetingNote = { ...this.state.meetingNote }
    meetingNote.sketches[index].mocks = value
    this.setState({
      meetingNote
    })
  }

  saveMeetingNote = e => {
    e.preventDefault()
    let meetingNote = { ...this.state.meetingNote }
    if (this.state._id !== "") meetingNote._id = this.state._id
    meetingNote.sketches = meetingNote.sketches.map((sketch, index) => {
      let data = { ...sketch }
      data.imageName =
        this.state.meetingNoteIDandBarcode.MNId + "-" + parseInt(index) + 1
      // data.imageDescription = 'mydesc'
      if (Array.isArray(data.pendingItem) && data.pendingItem.length > 0) {
        if (data.pendingItem[0] !== null) {
          if (Object.keys(data.pendingItem[0]).length > 0) {
            data.pendingItem = data.pendingItem.map(dat => {
              return (dat = dat.value)
            })
          }
        }
      }
      if (Array.isArray(data.mocks) && data.mocks.length > 0) {
        if (data.mocks[0] !== null) {
          if (Object.keys(data.mocks[0]).length > 0) {
            data.mocks = data.mocks.map(dat => {
              return (dat = dat.value)
            })
          }
        }
      }
      return data
    })
    MeetingNotesServices.createMeetingNote(meetingNote)
      .then(response => {
        if (response.status == 200) {
          this.props.getalertMessage("success", response.text.message)
          this.setState({
            _id: response.text.data._id,
            meetingNoteIDandBarcode: {
              ...this.state.meetingNoteIDandBarcode,
              _id: response.text.data._id
            }
          })
        }
        response.status === 401 && this.props.unauthorisedFunc()
      })
      .catch(error => this.props.getalertMessage("error", error.toString()))
  }
  changeIBSize = (index, indexVal, methodName) => {
    let { meetingNote } = this.state
    let sketch = meetingNote.sketches[index]
    methodName === "add"
      ? sketch.IB.push({
        price: null,
        qty: null,
        date: null
      })
      : sketch.IB.splice(indexVal, 1)
    meetingNote.sketches[index] = sketch
    this.setState({ meetingNote })
  }
  changeShippingSize = (index, indexVal, methodName) => {
    let { meetingNote } = this.state
    let sketch = meetingNote.sketches[index]
    methodName === "add"
      ? sketch.shipmentDetails.push({ quantity: null, date: "" })
      : sketch.shipmentDetails.splice(indexVal, 1)

    meetingNote.sketches[index] = sketch
    this.setState({ meetingNote })
  }

  removeShippingValueDetails = (e, indexVal, index) => {
    e.preventDefault()
    let { meetingNote } = this.state
    let sketches = meetingNote.sketches
    let shipmentDetails = sketches[index].shipmentDetails
    // shipmentDetails.filter(value => shipmentDetails.indexOf(value) !== indexVal)
    shipmentDetails.splice(indexVal, 1)
    sketches[index].shipmentDetails = shipmentDetails
    meetingNote.sketches = sketches
    this.setState({ meetingNote: meetingNote })
  }

  getStyleInfo = value => {
    if (value !== null) {
      DevelopmentServices.getMagnumStyleNoWithReference(value)
        .then(response => {
          if (response.status === 200) {
            let jsonData = []
            response.text.data.map((info, index) => {
              let objData = {}
              objData.label = info.referenceCode
              objData.value = info.referenceId
              jsonData.push(objData)
            })
            this.setState({ styleList: jsonData })
          }
        })
        .catch(error => this.props.getalertMessage("error", error.toString()))
    }
  }

  changeStyleInfo = async (styleValue, index) => {
    if (styleValue !== null) {
      let { meetingNote } = this.state
      meetingNote.sketches[index].styleReferenceId = styleValue.value
      await this.getStyleInfoById(styleValue.value)
      await StyleServices.getStyleInfoByReference(styleValue.value)
        .then(response => {
          if (response.status === 200) {
            meetingNote.sketches[index].magnumStyleName =
              response.text.data.magnumStyleName
            meetingNote.sketches[index].customerRefNumber =
              response.text.data.customerRefNumber
            meetingNote.sketches[index].magnumStyleId =
              response.text.data.magnumStyleId
            this.setState({
              meetingNote
            })
          }
          response.status == 401 && this.props.unauthorisedFunc()
        })
        .catch(error => this.props.getalertMessage("error", error.toString()))
    } else {
      let { meetingNote } = this.state
      meetingNote.sketches[index].magnumStyleName = ""
      meetingNote.sketches[index].customerRefNumber = ""
      meetingNote.sketches[index].magnumStyleId = null
      meetingNote.sketches[index].styleReferenceId = null
      this.setState({
        meetingNote
      })
    }
  }

  getStyleInfoById = id => {
    if (id !== null) {
      DevelopmentServices.getMagnumStyleNoWithReferenceById(id)
        .then(response => {
          if (response.status === 200) {
            let styleList = [...this.state.styleList, ...response.text.data]
            this.setState({ styleList })
          }
        })
        .catch(error => this.props.getalertMessage("error", error.toString()))
    }
  }

  openModal = image => {
    if (image != "" && image !== undefined) {
      this.setState({
        openmodal: true,
        image
      })
    }
  }

  onClose = () => {
    this.setState({
      openmodal: false
    })
  }

  addSketchImages = files => {
    let meetingNote = { ...this.state.meetingNote }
    this.setState({
      isLoading: true
    })
    if (files.length > 0) {
      FileUploadService.uploadMeetingNoteImage(files)
        .then(async response => {
          if (response.status == 200) {
            response.text.data.map(data => {
              meetingNote.sketches.push({
                sketchImage: data.url,
                sampleStyle: "",
                path: "",
                blockRefNumber: "",
                blockRefFrom: "",
                sketch: "",
                sampleDeadline: null,
                fabric: "",
                quality: "",
                artwork: "",
                trim: "",
                fitComments: "",
                wash: "",
                print: "",
                embroidery: "",
                garmentType: null,
                magnumStyleId: null,
                styleReferenceId: null,
                magnumStyleName: "",
                customerRefNumber: "",
                remarks: "",
                pendingItem: [],
                mocks: [],
                customerRefNumber: "",
                IB: [
                  {
                    price: null,
                    qty: null,
                    ibDate: null
                  }
                ],
                order: [
                  {
                    price: null,
                    qty: null,
                    ibDate: null
                  }
                ],
                shipmentDetails: [
                  {
                    quantity: null,
                    date: null
                  }
                ],
                additionalInfo: "",
                refImages: []
              })
            })
            this.setState({
              meetingNote,
              isLoading: false
            })
          } else if (response.status == 401) {
            this.props.unauthorisedFunc()
          } else {
            this.props.getalertMessage("error", response.text.message)
          }
        })
        .catch(error => this.props.getalertMessage("error", error.toString()))
    }
  }

  backToList = () => {
    this.setState({
      currentIndex: null,
      currentSketchData: null,
      openSubModule: false
    })
  }

  exportExcel = () => {
    this.setState({ isLoading: true })
    ReportServices.meetingNotesExcel(this.state._id)
      .then((res) => {
        let data = res.text.data
        var anchor = document.createElement("a")
        anchor.href = UtilityService.baseUrl() + data.link
        anchor.target = "_blank"
        anchor.download = UtilityService.baseUrl() + data.link
        this.setState({ isLoading: false })
        anchor.click()
      }).catch(error => this.props.getalertMessage("error", error.toString()))
  }

  render() {
    const { meetingNote } = this.state
    return (
      <Fragment>
        <div class="right-section bg-white">
          {this.state.isLoading && <Loading />}
          <div class="row nopadding">
            <div class="col-md-12 nopadding">
              <PageHeader history={this.props.history} header="Meeting Notes" />
              <Audit _id={this.state._id} />
              <button style={{ cursor: "pointer" }} className={"primary pull-right px-2 mr-3"} onClick={(e) => this.exportExcel()}>
                <img src={excelImg} width="20px" />
              </button>
              <div class="col-md-12">
                {/* <div class="col-md-2">
                  <img src={this.state.meetingNoteIDandBarcode.qr} />
                </div> */}
                <div class="col-md-2">
                  <Field
                    isFormGroup={true}
                    inputType="text"
                    value={meetingNote.MNId}
                    inputName="meetingID"
                    label={"Meeting ID"}
                    disabled={true}
                  />
                </div>
              </div>
              <div class="col-md-12">
                <div class="col-md-3">
                  <CustomerDeptSelect
                    options={this.state.customerList}
                    value={`${meetingNote.customer}-${meetingNote.customerDepartmentId}`}
                    onChange={this._handleCustDeptChange}
                    disabled={this.state.disabled}
                  />
                </div>
                <div class="col-md-2">
                  <Field
                    isFormGroup={true}
                    inputType="date"
                    value={meetingNote.dateOfMeeting}
                    inputName="dateOfMeeting"
                    label={"Date of meeting"}
                    onChange={this._handleInputChange}
                    disabled={this.state.disabled}
                  />
                </div>
                <div class="col-md-2">
                  <Field
                    isFormGroup={true}
                    inputType="text"
                    inputName="buyerName"
                    value={meetingNote.buyerName}
                    label={"Buyer Name"}
                    onChange={this._handleInputChange}
                    disabled={this.state.disabled}
                  />
                </div>
                <div class="col-md-3">
                  <Field
                    isFormGroup={true}
                    inputType="text"
                    inputName="present"
                    value={meetingNote.present}
                    label={"Present"}
                    onChange={this._handleInputChange}
                    disabled={this.state.disabled}
                  />
                </div>
                <div class="col-md-2">
                  <Field
                    isFormGroup={true}
                    inputType="text"
                    inputName="placeOfMeeting"
                    value={meetingNote.placeOfMeeting}
                    label={"Place of the meeting"}
                    onChange={this._handleInputChange}
                    disabled={this.state.disabled}
                  />
                </div>
              </div>
              {!this.state.openSubModule && (
                <Fragment>
                  {!this.state.disabled && (
                    <div class="col-md-12 px-5 mt-3">
                      <div className="pull-right">
                        <AddImageIcon onChange={this.addSketchImages} />
                      </div>
                    </div>
                  )}
                  <div className="col-md-12 px-5">
                    <div class="image-list">
                      {meetingNote.sketches.map((sketch, index) => {
                        return (
                          <Fragment>
                            <div className="image-card-index">
                              {`${meetingNote.MNId}-${index + 1}`}

                              <div
                                className="image-card cursor-hover"
                                onClick={() =>
                                  this.setState({
                                    openSubModule: true,
                                    currentIndex: index,
                                    currentSketchData: sketch
                                  })
                                }
                              >
                                <img
                                  src={
                                    UtilityService.fileUrl() +
                                    sketch.sketchImage
                                  }
                                />
                              </div>
                            </div>
                          </Fragment>
                        )
                      })}
                    </div>
                  </div>
                </Fragment>
              )}
            </div>
            <div className="col-md-12 nopadding">
              {this.state.openSubModule &&
                this.state.currentIndex !== null &&
                meetingNote.sketches.length > 0 && (
                  <SubModule
                    options={this.state.customerList}
                    meetingNoteID={this.state.meetingNoteIDandBarcode.MNId}
                    data={meetingNote.sketches[this.state.currentIndex]}
                    meetingNote={this.state.meetingNote}
                    index={this.state.currentIndex}
                    changeImg={this.changeImg}
                    removeMNoteImage={this.removeMNoteImage}
                    changeStyleInfo={this.changeStyleInfo}
                    getStyleInfo={this.getStyleInfo}
                    getStyleInfoById={this.getStyleInfoById}
                    selectNewSample={this.selectNewSample}
                    selectExistingSample={this.selectExistingSample}
                    selectNewIB={this.selectNewIB}
                    selectNewOrder={this.selectNewOrder}
                    updateValue={this.updateValue}
                    changeGarmentType={this.changeGarmentType}
                    changePendingItem={this.changePendingItem}
                    changeMocks={this.changeMocks}
                    ibValueChange={this.ibValueChange}
                    changeIBSize={this.changeIBSize}
                    shippingValueChange={this.shippingValueChange}
                    changeShippingSize={this.changeShippingSize}
                    getRefImages={this.getRefImages}
                    saveMeetingNote={this.saveMeetingNote}
                    generateStyle={this.generateStyle}
                    backToList={this.backToList}
                    removeSketch={this.removeSketch}
                    styleList={this.state.styleList}
                    garmentTypeOption={this.state.garmentTypeOption}
                    imageTypeOption={this.state.imageTypeOption}
                    disabled={this.state.disabled}
                    history={this.props.history}
                  />
                )}
            </div>
            <ButtonCol
              saveFunc={() => {
                this.createMeetingNote()
                // setTimeout(() => this.props.history.goBack(), 1200)
              }}
              disabled={this.state.disabled}
            />
          </div>
        </div>
        <Modal open={this.state.openmodal} onClose={this.onClose} center>
          <img src={UtilityService.fileUrl() + this.state.image} />
        </Modal>
      </Fragment>
    )
  }
}

export default MeetingNote


// WEBPACK FOOTER //
// ./src/pages/MeetingNote/page.js